export default __webpack_public_path__ + "static/media/JobOne2.abba65c2.JPG";